/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RegistrationVatConsistencyStatus = {
    Consistent: 'CONSISTENT',
    Inconsistent: 'INCONSISTENT',
    Unknown: 'UNKNOWN'
} as const;
export type RegistrationVatConsistencyStatus = typeof RegistrationVatConsistencyStatus[keyof typeof RegistrationVatConsistencyStatus];


export function instanceOfRegistrationVatConsistencyStatus(value: any): boolean {
    for (const key in RegistrationVatConsistencyStatus) {
        if (Object.prototype.hasOwnProperty.call(RegistrationVatConsistencyStatus, key)) {
            // @ts-ignore
            if (RegistrationVatConsistencyStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RegistrationVatConsistencyStatusFromJSON(json: any): RegistrationVatConsistencyStatus {
    return RegistrationVatConsistencyStatusFromJSONTyped(json, false);
}

export function RegistrationVatConsistencyStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationVatConsistencyStatus {
    return json as RegistrationVatConsistencyStatus;
}

export function RegistrationVatConsistencyStatusToJSON(value?: RegistrationVatConsistencyStatus | null): any {
    return value as any;
}

